var map = {
	"./answer-input.png": "d82a",
	"./beep-code.png": "dbea",
	"./bg-game.png": "7171",
	"./bg-home.png": "d6f1",
	"./bg-score.png": "665b",
	"./color-span.png": "aab2",
	"./digit-span–backward.png": "e71d",
	"./digit-span–forward.png": "c700",
	"./image-footer-1.png": "86fc",
	"./image-footer-2.png": "5c89",
	"./image-title-casual.png": "df0d",
	"./image-title1.png": "3e68",
	"./image-title2.png": "401d",
	"./image-view-score.png": "3169",
	"./lineNameTest.png": "3d2d",
	"./number-sequences.png": "e7cd",
	"./object.png": "4096",
	"./pair-associates-learning.png": "cfb9",
	"./play.png": "a8d5",
	"./spatial-span-color-sequence.png": "ff5b",
	"./spatial-span-sequence.png": "764f",
	"./spatial-span-working-memory.png": "5b82",
	"./spatial-span.png": "0793",
	"./speak.png": "b03f",
	"./stick.png": "b9c2",
	"./word-recognition.png": "8a7e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "de3c";